// extracted by css-extract-rspack-plugin
export default {"note":"OfficeForm__note--OGdpj"};